import React from 'react'
import Link from 'next/link'
import { Breadcrumbs } from '@mui/material'
import {
  FirstDepthCatalogCategoryFragment,
  SecondDepthCatalogCategoryFragment,
  ThirdDepthCatalogCategoryFragment,
} from '@services/cloud/client'

type Category = {
  firstDepth?: Pick<FirstDepthCatalogCategoryFragment, 'categoryId' | 'name'> | null
  secondDepth?: Pick<SecondDepthCatalogCategoryFragment, 'categoryId' | 'name'> | null
  thirdDepth?: Pick<ThirdDepthCatalogCategoryFragment, 'categoryId' | 'name'> | null
}

type Props = {
  category: Category
}

export const CatalogCategoryBreadcrumbs: React.VFC<Props> = (props) => (
  <Breadcrumbs aria-label="breadcrumb">
    <Link href={'/catalogs'}>トップページ</Link>
    {props.category?.firstDepth?.categoryId && (
      <Link href={`/catalogs/category/${props.category.firstDepth?.categoryId}`}>
        {props.category.firstDepth?.name}
      </Link>
    )}
    {props.category?.secondDepth?.categoryId && (
      <Link
        href={`/catalogs/category/${props.category.firstDepth?.categoryId}/${props.category.secondDepth?.categoryId}`}
      >
        {props.category.secondDepth?.name}
      </Link>
    )}
    {props.category?.thirdDepth?.categoryId && (
      <Link
        href={`/catalogs/category/${props.category.firstDepth?.categoryId}/${props.category.secondDepth?.categoryId}/${props.category.thirdDepth?.categoryId}`}
      >
        {props.category.thirdDepth?.name}
      </Link>
    )}
  </Breadcrumbs>
)
